"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BitpingValidator = exports.DNSValidator = exports.SeleniumValidator = exports.HTTPVerbsValidator = exports.HTTPHeadValidator = exports.HTTPDeleteValidator = exports.HTTPOptionsValidator = exports.HTTPPatchValidator = exports.HTTPPutValidator = exports.HTTPPostValidator = exports.HTTPGetValidator = exports.HLSValidator = exports.LoadValidator = exports.PingValidator = exports.IPv6EndpointPort = exports.IPv6Endpoint = exports.IPv6HttpPort = exports.IPv6Port = exports.IPv6Http = exports.IPv6 = exports.IPv4Endpoint = exports.IPv4HttpPort = exports.IPv4Port = exports.IPv4Http = exports.IPv4 = exports.EndpointValidator = exports.HostnameValidator = exports.BlankValidator = void 0;
var MonitorTypes_1 = require("../models/MonitorTypes");
// Endpoint validators
var BlankValidator = function (endpoint) {
    return (!endpoint || endpoint === '');
};
exports.BlankValidator = BlankValidator;
var HostnameValidator = function (endpoint) {
    try {
        if (!/^(([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9\-]*[a-zA-Z0-9])\.)+(?![0-9])(\w|\-)+$/.test(endpoint)) {
            throw new Error("Regex mismatch");
        }
        var x = new URL("http://" + endpoint);
        return (x.host === endpoint);
    }
    catch (e) {
        return false;
    }
};
exports.HostnameValidator = HostnameValidator;
var EndpointValidator = function (endpoint) {
    try {
        return /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/){1}(([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9\-]*[a-zA-Z0-9])\.)+(?![0-9])(\w|\-)+(\:[0-9]{1,5})?(\/.+)*(\/?)$/.test(endpoint);
    }
    catch (e) {
        return false;
    }
};
exports.EndpointValidator = EndpointValidator;
var IPv4 = function (endpoint) {
    try {
        return /^((?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(endpoint);
    }
    catch (e) {
        return false;
    }
};
exports.IPv4 = IPv4;
var IPv4Http = function (endpoint) {
    try {
        return /^(http:\/\/)((?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(endpoint);
    }
    catch (e) {
        return false;
    }
};
exports.IPv4Http = IPv4Http;
var IPv4Port = function (endpoint) {
    try {
        return /^((?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)[:]\d{1,5}$/.test(endpoint);
    }
    catch (e) {
        return false;
    }
};
exports.IPv4Port = IPv4Port;
var IPv4HttpPort = function (endpoint) {
    try {
        return /^(http:\/\/)((?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)([:]\d{1,5})$/.test(endpoint);
    }
    catch (e) {
        return false;
    }
};
exports.IPv4HttpPort = IPv4HttpPort;
var IPv4Endpoint = function (endpoint) {
    try {
        return /^(http:\/\/)((?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(\:[0-9]{1,5})?(\/.+)*(\/?)$/.test(endpoint);
    }
    catch (e) {
        return false;
    }
};
exports.IPv4Endpoint = IPv4Endpoint;
var IPv6 = function (endpoint) {
    try {
        return /^(([0-9A-Fa-f]{0,4}:){1,7}([0-9A-Fa-f]{0,4}|:))$/.test(endpoint);
    }
    catch (e) {
        return false;
    }
};
exports.IPv6 = IPv6;
var IPv6Http = function (endpoint, protocol, port) {
    if (protocol === void 0) { protocol = false; }
    if (port === void 0) { port = false; }
    try {
        return /^(http:\/\/)(([0-9A-Fa-f]{0,4}:){1,7}([0-9A-Fa-f]{0,4}|:))$/.test(endpoint);
    }
    catch (e) {
        return false;
    }
};
exports.IPv6Http = IPv6Http;
var IPv6Port = function (endpoint) {
    try {
        return /^\[(([0-9A-Fa-f]{0,4}:){1,7}([0-9A-Fa-f]{0,4}|:))\][:]\d{1,5}$/.test(endpoint);
    }
    catch (e) {
        return false;
    }
};
exports.IPv6Port = IPv6Port;
var IPv6HttpPort = function (endpoint, protocol, port) {
    if (protocol === void 0) { protocol = false; }
    if (port === void 0) { port = false; }
    try {
        return /^(http:\/\/)\[(([0-9A-Fa-f]{0,4}:){1,7}([0-9A-Fa-f]{0,4}|:))\][:]\d{1,5}$/.test(endpoint);
    }
    catch (e) {
        return false;
    }
};
exports.IPv6HttpPort = IPv6HttpPort;
var IPv6Endpoint = function (endpoint) {
    try {
        return /^(http:\/\/)(([0-9A-Fa-f]{0,4}:){1,7}([0-9A-Fa-f]{0,4}|:))(\/.+)*(\/?)$/.test(endpoint);
    }
    catch (e) {
        return false;
    }
};
exports.IPv6Endpoint = IPv6Endpoint;
var IPv6EndpointPort = function (endpoint) {
    try {
        return /^(http:\/\/)(\[)(([0-9A-Fa-f]{0,4}:){1,7}([0-9A-Fa-f]{0,4}|:))(\])([:]\d{1,5})(\/.+)*(\/?)$/.test(endpoint);
    }
    catch (e) {
        return false;
    }
};
exports.IPv6EndpointPort = IPv6EndpointPort;
// Monitor validators
var PingValidator = function (endpoint) {
    for (var _i = 0, _a = [
        exports.HostnameValidator,
        exports.IPv4,
        exports.IPv6
    ]; _i < _a.length; _i++) {
        var test = _a[_i];
        if (!!test(endpoint))
            return true;
    }
    return false;
};
exports.PingValidator = PingValidator;
var LoadValidator = function (endpoint) {
    for (var _i = 0, _a = [
        exports.EndpointValidator,
        exports.IPv4Http,
        exports.IPv4HttpPort,
        exports.IPv4Endpoint,
        exports.IPv6Http,
        exports.IPv6Http,
        exports.IPv6HttpPort,
        exports.IPv6Endpoint,
        exports.IPv6EndpointPort
    ]; _i < _a.length; _i++) {
        var test = _a[_i];
        if (test(endpoint))
            return true;
    }
    return false;
};
exports.LoadValidator = LoadValidator;
var HLSValidator = function (endpoint) {
    return exports.LoadValidator(endpoint);
};
exports.HLSValidator = HLSValidator;
var HTTPGetValidator = function (endpoint) {
    return exports.HTTPVerbsValidator(endpoint);
};
exports.HTTPGetValidator = HTTPGetValidator;
var HTTPPostValidator = function (endpoint) {
    return exports.HTTPVerbsValidator(endpoint);
};
exports.HTTPPostValidator = HTTPPostValidator;
var HTTPPutValidator = function (endpoint) {
    return exports.HTTPVerbsValidator(endpoint);
};
exports.HTTPPutValidator = HTTPPutValidator;
var HTTPPatchValidator = function (endpoint) {
    return exports.HTTPVerbsValidator(endpoint);
};
exports.HTTPPatchValidator = HTTPPatchValidator;
var HTTPOptionsValidator = function (endpoint) {
    return exports.HTTPVerbsValidator(endpoint);
};
exports.HTTPOptionsValidator = HTTPOptionsValidator;
var HTTPDeleteValidator = function (endpoint) {
    return exports.HTTPVerbsValidator(endpoint);
};
exports.HTTPDeleteValidator = HTTPDeleteValidator;
var HTTPHeadValidator = function (endpoint) {
    return exports.HTTPVerbsValidator(endpoint);
};
exports.HTTPHeadValidator = HTTPHeadValidator;
var HTTPVerbsValidator = function (endpoint) {
    return exports.LoadValidator(endpoint);
};
exports.HTTPVerbsValidator = HTTPVerbsValidator;
var SeleniumValidator = function (endpoint) {
    for (var _i = 0, _a = [
        exports.BlankValidator,
        exports.LoadValidator
    ]; _i < _a.length; _i++) {
        var test = _a[_i];
        if (!!test(endpoint || ""))
            return true;
    }
    return false;
};
exports.SeleniumValidator = SeleniumValidator;
var DNSValidator = function (endpoint) {
    return exports.HostnameValidator(endpoint);
};
exports.DNSValidator = DNSValidator;
var BitpingValidator = function (test, endpoint) {
    switch (test) {
        case MonitorTypes_1.MonitorTypes.Ping:
            return exports.PingValidator(endpoint);
        case MonitorTypes_1.MonitorTypes.LoadTime:
            return exports.LoadValidator(endpoint);
        case MonitorTypes_1.MonitorTypes.DNSPropagation:
            return exports.DNSValidator(endpoint);
        case MonitorTypes_1.MonitorTypes.HLS:
            return exports.HLSValidator(endpoint);
        case MonitorTypes_1.MonitorTypes.Selenium:
            return exports.SeleniumValidator(endpoint);
        case MonitorTypes_1.MonitorTypes.HTTPGet:
        case MonitorTypes_1.MonitorTypes.HTTPPost:
        case MonitorTypes_1.MonitorTypes.HTTPPut:
        case MonitorTypes_1.MonitorTypes.HTTPPatch:
        case MonitorTypes_1.MonitorTypes.HTTPOptions:
        case MonitorTypes_1.MonitorTypes.HTTPDelete:
        case MonitorTypes_1.MonitorTypes.HTTPHead:
            return exports.HTTPVerbsValidator(endpoint);
        default:
            throw new Error("Invalid test type");
    }
};
exports.BitpingValidator = BitpingValidator;
